import ScrollNavbar from '../utils/ScrollNavbar';
import ShowNavSide from '../utils/ShowNavSide';
//import Search from '../utils/Search';
import LivewireConfigurator from '../utils/LivewireConfigurator';
import LottieAnimation from '../vendor/LottieAnimation';
import BtnSendAnimation from '../utils/BtnSendAnimation';
import MatomoEvent from '../utils/MatomoEvent';
import KonamiManager from '../vendor/Konami';
import Algolia from '../vendor/Algolia';
import footer from '../layouts/front/footer';
import '../vendor/CarbonBadge';
import Easter from '../games/easter';

// Scripts that will be used globally on the front.

// Common global scripts
require('./common');

// Custom
ScrollNavbar.init();
ShowNavSide.init();
LivewireConfigurator.init();
MatomoEvent.init();
footer.init();

// Vendor
KonamiManager.init();
LottieAnimation.init();
BtnSendAnimation.init();
Algolia.init();

// Games
Easter.register();

if (performance.getEntriesByType('navigation')[0].type === 'reload') {
    document.querySelector('.transition-cover').classList.add('hidden');
}
